import React from 'react'

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined'
import { Stack, Tooltip, Typography } from '@mui/material'

// A failed usage fetch has to say so. Rendering a dash or an empty cell reads as "nothing used",
// which is the one conclusion the data does not support.
const UsageUnavailable = () => (
  <Tooltip title="We could not read this customer's usage. The limit beside it is still accurate.">
    <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center', color: 'text.disabled' }}>
      <ErrorOutlineIcon fontSize="small" />
      <Typography variant="caption">Usage unavailable</Typography>
    </Stack>
  </Tooltip>
)

export default UsageUnavailable
